//
//
//
//
//
//
//
//
//

export default {
  name: 'Payment'
};